'use strict';

module.exports = {
  /**
   * 获取TARS的userID
   */
  getUserId: function getUserId() {
    var userId = __tars_config__ && __tars_config__.userId;
    if (!userId) {
      userId = this.getCookie('tars_USER_COOKIE') || this.getCookie('TwAhx8HL') || this.getCookie('cookie2');
    }
    return userId;
  },


  /**
   * 获取cookie值
   * @param {string} key 入参
   */
  getCookie: function getCookie(key) {
    var cookie_str = document.cookie;
    var cookie_arr = cookie_str.split('; ');
    var cookie_obj = {};
    cookie_arr.map(function (item) {
      var kv = item.split('=');
      cookie_obj[kv[0]] = kv[1];
      return item;
    });

    return key ? cookie_obj[key] : cookie_obj;
  },


  /**
   * 设置cookie
   * @param {string} key 设置cookie的key
   * @param {any} value cookie的值
   * @param {number} second 过期时间，单位s
   */
  setCookie: function setCookie(key, value, second) {
    var expires = "";
    if (second) {
      var date = new Date();
      date.setTime(date.getTime() + second * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = key + "=" + (value || "") + expires + "; path=/";
  }
};